// extracted by mini-css-extract-plugin
export default {"tooltip":"Qp-z","sharingV2":"Rp-z","sharingIconsV2":"Sp-z","links":"Tp-z","link":"Up-z","facebookV2":"Vp-z","twitterV2":"Wp-z","pinterestV2":"Xp-z"};